// @ts-nocheck

import { Table } from 'antd'
import PropTypes from 'prop-types'
import React from 'react'

import { formatTableColumns, formatTableRows } from './utils'

/**
@param {array} columns. The columns for the table.
@param {string} containerClass. Class name for the container div. Allows custom stylings to be passed down.
@param {func} onChange. Function that fires when pagination, filters or sorter is changed.
@param {bool, object} pagination. Toggles whether or not to have pagination for the table.
@param {array} rows. The rows for the table.
* */

export default function AntdTable(props) {
  const { columns, containerClass, onChange, pagination = false, rows } = props

  return (
    <div className={containerClass}>
      <Table
        columns={formatTableColumns(columns)}
        dataSource={formatTableRows(columns, rows)}
        onChange={onChange}
        pagination={pagination}
      />
    </div>
  )
}

AntdTable.propTypes = {
  columns: PropTypes.array.isRequired,
  containerClass: PropTypes.string,
  rows: PropTypes.array.isRequired,
  pagination: PropTypes.oneOfType([PropTypes.bool, PropTypes.object])
}
